import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  TabContent, TabPane, Nav, NavItem, NavLink
} from 'reactstrap';
import classnames from 'classnames';
import ReligionList from '../Religion/ReligionList';
import $ from 'jquery';
import StudentPage from '../../views/StudentPage';

class CasteUpdate extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			casName : '',
			communi : '',
			relName : '',
			_message : '',
			value : '',
			alertClass :'',
			shown : false,
			activeTab: '1',
			commun : [],
		}
		this.handleInputChange = this.handleInputChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onRelSubmit = this.onRelSubmit.bind(this);
		this.toggle = this.toggle.bind(this);
	}
	
	toggle(tab) {
		if (this.state.activeTab !== tab) {
		  this.setState({
			activeTab: tab
		  });
		}
	}
	
	/** set value **/
	handleInputChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	/** submit caste form **/
	onSubmit(e){
		e.preventDefault();
		 $("#showLoader").show();
		if(this.state.casName && this.state.communi){
			
			PostData('caste/updatecaste',this.state).then((result) => {
				 $("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Caste Updated Successfully!..',
						alertClass:'alert alert-success'
					});
					document.getElementById("caseditform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});	
		}
	}
	
	onRelSubmit(e){
		e.preventDefault();
		 $("#showLoader").show();
		if(this.state.relName){
			
			PostData('caste/addreligion',this.state).then((result) => {
				 $("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Religion has been Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("casform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getcaste();
		this.getcommunity();
	}
	
	/** get Caste **/
	getcaste(){
		 $("#showLoader").show();
		GetData('caste/getcastebyid/'+this.props.match.params.id).then((result) => {
			 $("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
				casName : res[0]['caste'],
				communi : res[0]['community']
			});
			}
		});
	}
	
	/** get Community **/
	getcommunity(){
		 $("#showLoader").show();
		GetData('caste/getcommunity').then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					commun : responseJson
				});
			}
		});
	}
	
  render() {
	  
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/settings/caste' />);
	}
	
	var com = this.state.commun;
  
    return (
		<div>
		  <StudentPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			<Row>
			  <Col md="12">
				<Nav tabs>
				  <NavItem>
					<NavLink
					  className={classnames({ active: this.state.activeTab === '1' })}
					  onClick={() => { this.toggle('1'); }}
					>
					  Student caste
					</NavLink>
				  </NavItem>
				  <NavItem>
					<NavLink
					  className={classnames({ active: this.state.activeTab === '2' })}
					  onClick={() => { this.toggle('2'); }}
					>
					  Student Religion
					</NavLink>
				  </NavItem>
				</Nav>
				<TabContent activeTab={this.state.activeTab}>
				  <TabPane tabId="1">
					<Row>
					<Col md="6">
					<Card>
					  <form action="" method="post" role="form" id="caseditform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader className="card-header-inner">
							<strong>Edit Caste</strong>
						</CardHeader>
						<CardBody>
						  <Row>
							<Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Caste Name</Label>
								  <Input type="text" name="casName" id="name" required onChange={this.handleInputChange} value={this.state.casName} />
								</FormGroup>
							</Col>
							<Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Community</Label>
								  <select name="communi" className="form-control" onChange={this.handleInputChange} required value={this.state.communi}>
									<option value="">Select</option>
										{
											com.map(function (item) {
												return <option value={item.id}>{item.community}</option>;
											})
										}
								  </select>
								</FormGroup>
							</Col>
						  </Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					  </form>
					</Card>
					</Col>
					</Row>
				  </TabPane>
				  <TabPane tabId="2">
					<Row>
					<Col md="6">
					<Card>
					  <form action="" method="post" role="form" id="relform" encType="multipart/form-data" onSubmit={this.onRelSubmit} >
						<CardHeader className="card-header-inner">
							<strong>Add Religion</strong>
						</CardHeader>
						<CardBody>
						  <Row>
							<Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Religion Name</Label>
								  <Input type="text" name="relName" id="name" required onChange={this.onChange} />
								</FormGroup>
							</Col>
						  </Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.relClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
					</Col>
					<Col md="6">
						<ReligionList />
					</Col>
					</Row>
				  </TabPane>
				</TabContent>
			  </Col>
			</Row>
			</div>
		</div>
	);
  }
}

export default CasteUpdate;



// WEBPACK FOOTER //
// ./src/settings/Caste/CasteUpdate.js